export default __webpack_public_path__ + "img/f21ac09511c6fa4f94633549c5716665.woff2";